import { DateTimeString, getDateTimeString } from "../../dateTypes.js";
import { typedObjectEntries } from "../../utils/typedObjects.js";
import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";
import { AppSession } from "../AppSessionEventState.js";

export const UPDATE_APP_SESSION = createAppSessionEventDefinition({
  type: "UPDATE_APP_SESSION",
  logSafe: {
    state: true,
    totalMemory: true,
    availableMemory: true,
    maxMemory: true,
    lastRunStart: true,
    lastRunEnd: true,
  },
  create: ({
    lastRunEnd,
    lastRunStart,
    ...rest
  }: Partial<
    Omit<AppSession, "lastRunStart" | "lastRunEnd"> & {
      lastRunStart: Date | DateTimeString | null;
      lastRunEnd: Date | DateTimeString | null;
    }
  >) => ({
    lastRunStart:
      lastRunStart instanceof Date
        ? getDateTimeString(lastRunStart)
        : lastRunStart,
    lastRunEnd:
      lastRunEnd instanceof Date ? getDateTimeString(lastRunEnd) : lastRunEnd,
    ...rest,
  }),
  apply: (previousState, payload) => {
    for (const entry of typedObjectEntries(payload)) {
      if (entry != null) {
        //  we know that this key must match
        previousState.appSession[entry[0]] = entry[1] as never;
      }
    }
  },
});
